import React from 'react';
import Tabs from 'components/utilities/tabs/Tabs';

// Import helrpes
import { settingsTabs } from './helpers/index';

const SettingsTabs = () => <Tabs tabs={settingsTabs} />;

export default SettingsTabs;
